export var LogtoStateKey = /* @__PURE__ */ ((LogtoStateKey2) => {
  LogtoStateKey2["User"] = "logto.user";
  return LogtoStateKey2;
})(LogtoStateKey || {});
export const defaults = Object.freeze({
  endpoint: "<replace-with-logto-endpoint>",
  appId: "<replace-with-logto-app-id>",
  appSecret: "<replace-with-logto-app-secret>",
  cookieEncryptionKey: "<replace-with-random-string>"
});
